import React from 'react';
import { SearchSuggestionChipWrapper } from './SearchSuggestionChip.styles.js';

var SearchSuggestionChip = function SearchSuggestionChip(_a) {
  var text = _a.text,
      disabled = _a.disabled,
      onClick = _a.onClick,
      hoverBackgroundColor = _a.hoverBackgroundColor,
      hoverBorderColor = _a.hoverBorderColor;
  return React.createElement(SearchSuggestionChipWrapper, {
    onClick: disabled ? function () {} : onClick,
    disabled: disabled,
    hoverBackgroundColor: hoverBackgroundColor,
    hoverBorderColor: hoverBorderColor
  }, text);
};

export { SearchSuggestionChip };